import moment from 'moment';
import { api } from './api';
import CacheStorage from './CacheStorage';

const baseURL = `${process.env.REACT_APP_API_URL}api`;

const cacheStorage = new CacheStorage();

const year = moment().year() + 2;

const yearsArray = [
  year - 5,
  year - 4,
  year - 3,
  year - 2,
  year - 1,
  year,
  year + 1,
  year + 2,
  year + 3,
];

const fetchYears = async () => {
  yearsArray.forEach(async (element) => {
    const url = `${baseURL}/drill/calendar/?plannedWeeks=&referenceYear=${element}&monthNumbers=&page=1&pageSize=10&needToChange=true`;
    await api.getAll(url);
    await api.getAll(`${baseURL}/me/weeks/${element}`);
  });
};

const updateCachedDrill = async (data) => {
  const url = `${baseURL}/drill/report/${data.id}`;
  await cacheStorage.updateCache(data, url);
};

const clearOldYear = async (data) =>
  yearsArray.forEach(async (element) => {
    if (element !== data.referenceYear) {
      const url = `${baseURL}/drill/calendar/?plannedWeeks=&referenceYear=${element}&monthNumbers=&page=1&pageSize=10&needToChange=true`;
      const items = await cacheStorage.getFromCache(url);

      if (items && items.itemList) {
        const index = items.itemList.findIndex((el) => el.id === data.id);
        items.itemList.splice(index, 1);
        items.rowCount -= 1;
      }
      if (items) await cacheStorage.updateCache(items, url);
    }
  });

const updateCachedDrillList = async (data) => {
  await clearOldYear(data);
  const url = `${baseURL}/drill/calendar/?plannedWeeks=&referenceYear=${data.plannedYear}&monthNumbers=&page=1&pageSize=10&needToChange=true`;
  const items = await cacheStorage.getFromCache(url);

  if (items && items.itemList) {
    const element = items.itemList.find((el) => el.id === data.id);

    if (!element || element == null) {
      items.itemList = items.itemList.concat([data]);
      items.rowCount += 1;
    } else {
      items.itemList[items.itemList.indexOf(element)] = data;
    }

    await cacheStorage.updateCache(items, url);
  }
};

const updateCachedCarList = async (data) => {
  let url = `${baseURL}/drill/report/${data.idDrillReport}`;
  const drill = await cacheStorage.getFromCache(url);
  if (drill) {
    const answer = drill.drillCheckListRequirementAnswers.find(
      (el) => el.id === data.idDrillCheckListRequirementAnswer
    );

    answer.car = data;
    answer.idDrillCar = data.id;

    drill.drillCheckListRequirementAnswers[
      drill.drillCheckListRequirementAnswers.indexOf(answer)
    ] = answer;

    await cacheStorage.updateCache(drill, url);
  }
  url = `${baseURL}/drill/report/${data.idDrillReport}/car`;
  const items = (await cacheStorage.getFromCache(url)) || { drillCAR: [] };
  if (drill) {
    items.drillReport = {
      id: drill.id,
      idCompiler: drill.idCompiler,
      idApprover: drill.idApprover,
      idDivisionManager: drill.idDivisionManager,
      idStatus: drill.idStatus,
    };
  } else {
    items.drillReport = {
      id: data.idDrillReport
    };
  }
  
  if (!items.drillCode && drill) {
    items.drillCode = drill.drillReportCode;
  }
  const element = items.drillCAR.find((el) => el.id === data.id);
  if (element == null) {
    items.drillCAR = items.drillCAR.concat([data]);
  } else {
    items.drillCAR[items.drillCAR.indexOf(element)] = data;
  }
  await cacheStorage.updateCache(items, url);
  url = `${baseURL}/drill/report/answer/car/${data.id}`;
  await cacheStorage.updateCache(data, url);
};

const getCachedDrillList = async (referenceYear) => {
  const url = `${baseURL}/drill/calendar/?plannedWeeks=&referenceYear=${referenceYear}&monthNumbers=&page=1&pageSize=10&needToChange=true`;
  const drills = await cacheStorage.getFromCache(url);
  return drills || [];
};


const updateDrillFilter = async (data) => {
    const url = `${baseURL}/drill/filter`;
    await cacheStorage.updateCache(data, url);
};
const updateDrillCalendarFilter = async (data) => {
    const url = `${baseURL}/drill/filter/calendar`;
    await cacheStorage.updateCache(data, url);
};
const getBackPaged = async () => {
    const url = `${baseURL}/drill/filter`;
    const items = await cacheStorage.getFromCache(url);
    return items || undefined;
};
const getBackPagedCalendar = async () => {
    const url = `${baseURL}/drill/filter/calendar`;
    const items = await cacheStorage.getFromCache(url);
    return items || undefined;
};

const updateReportDrillFilter = async (data) => {
    const url = `${baseURL}/drill/drillreportfilter`;
    await cacheStorage.updateCache(data, url);
};
const updateReportDrillCalendarFilter = async (data) => {
    const url = `${baseURL}/drill/filter/drillreportcalendar`;
    await cacheStorage.updateCache(data, url);
};
const getReportBackPaged = async () => {
    const url = `${baseURL}/drill/drillreportfilter`;
    const items = await cacheStorage.getFromCache(url);
    return items || undefined;
};
const getBackReportPagedCalendar = async () => {
    const url = `${baseURL}/drill/filter/drillreportcalendar`;
    const items = await cacheStorage.getFromCache(url);
    return items || undefined;
};

const DrillRepository = {
  updateCachedDrill,
  updateCachedDrillList,
  getCachedDrillList,
    updateCachedCarList,
    getBackPaged,
    getBackPagedCalendar,
    updateDrillFilter,
    updateDrillCalendarFilter,
    updateReportDrillFilter,
    updateReportDrillCalendarFilter,
    getReportBackPaged,
    getBackReportPagedCalendar,

  preFetch: async () => {
    await fetchYears();

    // await fetchDivisionWorkSiteProject();
    await api.getAll(`${baseURL}/drill/drilltype`);
    await api.getAll(`${baseURL}/admin/drilltypedetail`);
    await api.getAll(`${baseURL}/drill/participant`);
    await api.getAll(`${baseURL}/drill/frequency`);
  },
};
export default DrillRepository;
